var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 120,
    viewBox: "0 0 153 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 52,
    r: 52,
    fill: "#5932F3",
    fillOpacity: 0.42
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1028_11965)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1 16C67.3273 16 57.7978 21.3233 51.9987 29.4829C50.105 29.0363 48.1301 28.8 46.1 28.8C31.9615 28.8 20.5 40.2615 20.5 54.4C20.5 68.5385 31.9615 80 46.1 80L46.12 80H110.1C122.471 80 132.5 69.9712 132.5 57.6C132.5 45.2288 122.471 35.2 110.1 35.2C109.221 35.2 108.354 35.2506 107.502 35.349C102.598 23.9677 91.2797 16 78.1 16Z",
    fill: "#F9F5FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.1,
    cy: 54.4,
    rx: 25.6,
    ry: 25.6,
    fill: "url(#paint0_linear_1028_11965)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.1,
    cy: 48,
    r: 32,
    fill: "url(#paint1_linear_1028_11965)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.1,
    cy: 57.5999,
    rx: 22.4,
    ry: 22.4,
    fill: "url(#paint2_linear_1028_11965)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 19,
    r: 5,
    fill: "#F4EBFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 109,
    r: 7,
    fill: "#F4EBFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 35,
    r: 7,
    fill: "#F4EBFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 8,
    r: 4,
    fill: "#F4EBFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1028_11965)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 62,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#5932F3",
    fillOpacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 91.0001C70.5 91.3514 70.5 91.527 70.5157 91.6797C70.6457 92.9475 71.5626 93.9947 72.8021 94.2912C72.9513 94.3269 73.1255 94.3501 73.4737 94.3966L80.0656 95.2755C81.942 95.5257 82.8803 95.6508 83.6084 95.3612C84.2478 95.107 84.7803 94.6408 85.1168 94.0407C85.5 93.3572 85.5 92.4106 85.5 90.5176V81.4826C85.5 79.5895 85.5 78.643 85.1168 77.9595C84.7803 77.3594 84.2478 76.8931 83.6084 76.6389C82.8803 76.3494 81.942 76.4745 80.0656 76.7247L73.4737 77.6036C73.1255 77.65 72.9514 77.6732 72.8021 77.7089C71.5626 78.0054 70.6457 79.0527 70.5157 80.3204C70.5 80.4731 70.5 80.6488 70.5 81.0001M76.5 82.0001L80.5 86.0001M80.5 86.0001L76.5 90.0001M80.5 86.0001H67.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1028_11965",
    x: 0.5,
    y: 16,
    width: 152,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1028_11965"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1028_11965"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1028_11965"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1028_11965",
    result: "effect2_dropShadow_1028_11965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1028_11965",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1028_11965",
    x: 44.5,
    y: 54,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1028_11965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1028_11965",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1028_11965",
    x1: 26.4429,
    y1: 37.4858,
    x2: 71.7,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1028_11965",
    x1: 53.5285,
    y1: 26.8571,
    x2: 110.1,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1028_11965",
    x1: 92.8999,
    y1: 42.8,
    x2: 132.5,
    y2: 79.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingUp);
export default __webpack_public_path__ + "static/media/singUp.c9e29880616152a0bd07c0e72cb8951a.svg";
export { ForwardRef as ReactComponent };